<p-accordion id="accordion" [multiple]="false" (onOpen)="abrirAcordeon($event)">
  <p-accordionTab header="{{ 'PRODUCTOREFERENCIA.LBL_REFERENCIAS' | translate }}" [selected]="tabSeleccionado === 'REFOBL'">

    <div class="grid" *ngIf="carInformacionInicial">
      <div class="col-12 md:col-12 lg:col-12 text-center">
        <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
        <span>{{'LBL_PROCESANDO' | translate }}</span>
      </div>
    </div>
    <div *ngIf="!carInformacionInicial && tab ==='L'">

      <div class="grid">
        <div class="col-12 md:col-6 lg:col-6">
          <button type="button" pButton icon="fa fa-plus" (click)="crear()" *ngIf="menu.agregar"
                  label="{{ 'LBL_AGREGAR' | translate}}"></button>
        </div>
        <div class="col-12 md:col-6 lg:col-6">
          <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
                 (input)="dt.filterGlobal($event.target.value, 'contains')"
                 [(ngModel)]="busqueda" (change)="setBusqueda()">
        </div>
      </div>

      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <p-table [columns]="columnas" [loading]="guardando" #dt
                   [value]="lisProductosReferencias" selectionMode="single" dataKey="idProductoReferencia"
                   [paginator]="true" [rows]="10"  paginatorPosition="bottom">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr [pSelectableRow]="row">
                <td>{{row.nombreTipoUsoCelular}}</td>
                <td>{{row.tipoReferencia}}</td>
                <td>{{row.tipoVinculacion}}</td>
                <td>{{row.tipoPersona}}</td>
                <td>{{row.numeroReferencias}}</td>
                <td class="text-center">
                  <p-checkbox [(ngModel)]="row.indicadorCanalAnalizamos" binary="true" disabled="true"></p-checkbox>
                </td>
                <td class="text-center">
                  <p-checkbox [(ngModel)]="row.indicadorCanalDigital" binary="true" disabled="true"></p-checkbox>
                </td>
                <td>{{row.idCuestionario ? row.cuestionario : ('LBL_NOAPLICA' | translate)}}</td>
                <td class="text-center">
                  <p-checkbox [(ngModel)]="row.indicadorCalificarReferencias" binary="true" disabled="true"></p-checkbox>
                </td>
                <td style="text-align: center;">{{row.funcionalidad ? row.funcionalidad : '-'}}</td>
                <td class="text-center">
                  <p-checkbox [(ngModel)]="row.indicadorObligatorio" binary="true" disabled="true"></p-checkbox>
                </td>
                <td>{{row.cuestionarioConfirmarReferencia}}</td>
                <td class="text-center">
                  <div class="btn-group" role="group">
                    <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                            title="{{'BTN_EDITAR' | translate}}" pButton
                            (click)="editar(row)"></button>
                    <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                            title="{{'BTN_INHABILITAR' | translate}}" pButton
                            (click)="inhabilitar(row)"></button>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length" class="text-center">
                  {{ 'MSG_NOHAYREGISTROS' | translate}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
    <div *ngIf="tab==='E'">
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <h1 class="titulo-pagina">{{ 'PRODUCTOREFERENCIA.LBL_REFERENCIAS' | translate}}</h1>
        </div>
      </div>
    </div>
    <div *ngIf="!carInformacionInicial && tab==='E'">

      <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fFormularioReferencia" name="nomFormularioReferencia">
        <div class="grid form-group">
          <div class="col-12 md:col-4 lg:col-4">
            <div class="div-form">
              <label>* {{ 'PRODUCTOREFERENCIA.LBL_TIPOREFERENCIA' | translate }}</label>
              <div *ngIf="!proReferenciaSeleccionada">
                <p-dropdown disableTab  id="idTipoReferencia" name="nomTipoReferencia" [options]="lisReferencia"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            optionValue="value"
                            optionLabel="label"
                             formControlName="idTipoReferencia"
                ></p-dropdown>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoReferencia.invalid">
                  {{ 'PRODUCTOREFERENCIA.LBL_TIPOREFERENCIA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
              <div *ngIf="proReferenciaSeleccionada && proReferenciaSeleccionada.idProductoReferencia !== undefined && proReferenciaSeleccionada.idProductoReferencia !== null && proReferenciaSeleccionada.idProductoReferencia !== ''">
                <label class="falso-combo-texto">{{proReferenciaSeleccionada.tipoReferencia}}</label>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-4 lg:col-4">
            <div class="div-form">
              <label>* {{ 'PRODUCTOREFERENCIA.LBL_TIPOVINCULACION' | translate }}</label>
              <div *ngIf="!proReferenciaSeleccionada">
                <p-dropdown disableTab  id="idTipoVinculacion" name="nomTipoVinculacion" [options]="lisVinculacion"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            optionValue="value"
                            optionLabel="label"
                             formControlName="idTipoVinculacion"
                ></p-dropdown>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoVinculacion.invalid">
                  {{ 'PRODUCTOREFERENCIA.LBL_TIPOVINCULACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
              <div *ngIf="proReferenciaSeleccionada && proReferenciaSeleccionada.idProductoReferencia !== undefined && proReferenciaSeleccionada.idProductoReferencia !== null && proReferenciaSeleccionada.idProductoReferencia !== ''">
                <label class="falso-combo-texto">{{proReferenciaSeleccionada.tipoVinculacion}}</label>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-4 lg:col-4">
            <div class="div-form">
              <label>* {{ 'PRODUCTOREFERENCIA.LBL_NATURALEZA' | translate }}</label>
              <p-multiSelect id="idTipoPersona" name="nomTipoPersona" [options]="listaTiposPersonas"
                             filter="filter"
                             defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                             selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idNaturaleza"
                             emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                             emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                             optionValue="value"
                             optionLabel="label"
              ></p-multiSelect>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idNaturaleza.invalid">
                {{ 'PRODUCTOREFERENCIA.LBL_NATURALEZA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
        </div>

        <div class="grid form-group">
          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label>* {{ 'PRODUCTOREFERENCIA.LBL_TIPOUSOCELULAR' | translate }}</label>
              <div *ngIf="!proReferenciaSeleccionada">
                <p-dropdown disableTab  id="idTipoUsoTelefono" name="nomTipoUsoCelular" [options]="lisTipoUsoCelular"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            optionValue="value"
                            optionLabel="label"
                             formControlName="idTipoUsoTelefono"
                ></p-dropdown>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoUsoTelefono.invalid">
                  {{ 'PRODUCTOREFERENCIA.LBL_TIPOUSOCELULAR' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
              <div *ngIf="proReferenciaSeleccionada && proReferenciaSeleccionada.idProductoReferencia !== undefined && proReferenciaSeleccionada.idProductoReferencia !== null && proReferenciaSeleccionada.idProductoReferencia !== ''">
                <label class="falso-combo-texto">{{proReferenciaSeleccionada.nombreTipoUsoCelular}}</label>
              </div>
            </div>
          </div>

          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label>* {{ 'PRODUCTOREFERENCIA.LBL_NUMEROREFERENCIAS' | translate }}</label>
              <input type="text" pInputText id="idNumeroReferencia"
                     name="nomNumeroReferencia"
                     autocomplete="off"
                     formControlName="numeroReferencias" numero-entero-reactive
                     [maxlength]="3" [minimo]="1"
              >
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.numeroReferencias.invalid">
                {{ 'PRODUCTOREFERENCIA.LBL_NUMEROREFERENCIAS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
        </div>


        <div class="grid form-group">
          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label>{{'PRODUCTOREFERENCIA.LBL_CUESTIONARIOSREF' | translate}}:</label>
              <p-dropdown disableTab  id="idCuestionario" name="nomIdCuestionario" [options]="lisCuestionarios"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                           formControlName="idCuestionario"
                          emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          optionValue="value"
                          optionLabel="label"
              ></p-dropdown>
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-6" *ngIf="f.indicadorCanalDigital.value">
            <div class="div-form">
              <p-checkbox label="{{ 'PRODUCTOREFERENCIA.LBL_PARENTESCOCHECK' | translate}}" binary="true"
                          id="indicadorParentesco"
                          name="nomIndicadorParentesco"
                          formControlName="indicadorParentesco"></p-checkbox>
            </div>
          </div>
        </div>


        <div class="grid form-group">
          <div class="col-12 md:col-6 lg:col-6 flex">
            <div class="col-4 md:col-4 lg:col-4">
              <p-checkbox label="{{ 'PRODUCTOREFERENCIA.LBL_CHECKCALIFICARREFERENCIA' | translate}}" binary="true"
                          id="indicadorCalificarReferencias"
                          name="nomIndicadorCalificarReferencias" (onChange)="cambioCheckRadicacion();validarFuncionalidadRequerida()"
                          formControlName="indicadorCalificarReferencias"></p-checkbox>
            </div>
            <div class="col-4 md:col-4 lg:col-4">
              <p-checkbox label="{{ 'PRODUCTOREFERENCIA.LBL_ANALIZAMOS' | translate}}" binary="true"
                          id="indicadorCanalAnalizamos"
                          name="nomindicadorCanalAnalizamos"
                          formControlName="indicadorCanalAnalizamos" (onChange)="validarFuncionalidadRequerida()"></p-checkbox>
            </div>
            <div class="col-4 md:col-4 lg:col-4">
              <p-checkbox label="{{ 'PRODUCTOREFERENCIA.LBL_DIGITAL' | translate}}" binary="true"
                          id="indicadorCanalDigital"
                          name="nomindicadorCanalDigital"
                          formControlName="indicadorCanalDigital" (onChange)="validarFuncionalidadRequerida()"></p-checkbox>
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-6" *ngIf="!f.indicadorParentesco.value && f.indicadorCanalDigital.value">
            <div class="div-form">
              <label>* {{'PRODUCTOREFERENCIA.LBL_PARENTESCO' | translate}}:</label>
              <p-multiSelect id="idParentescos" name="nomIdParentesco" [options]="listParentesco" filter="filter"
                             defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                             selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idParentescos"
                             emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                             emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                             optionValue="value"
                             optionLabel="label"
              ></p-multiSelect>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && !checkParentesco()">
                {{ 'PRODUCTOREFERENCIA.LBL_PARENTESCO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
        </div>

        <div class="grid form-group">
          <div class="grid col-12 md:col-6 lg:col-12" *ngIf="f.indicadorCalificarReferencias.value && f.indicadorCanalAnalizamos.value">
            <div class="col-6 div-form">
              <label>{{'PRODUCTOREFERENCIA.LBL_FUNCIONALIDAD' | translate}}:</label>
              <p-dropdown disableTab  id="idFuncionalidad" name="nomidFuncionalidad" [options]="lisCalificacionesReferencias"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                          formControlName="idFuncionalidad"
                          emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          optionValue="value"
                          optionLabel="label"
                          (onChange)="validarFuncionalidadSeleccionada($event.value)"
              ></p-dropdown>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && !f.idFuncionalidad.valid">
                {{ 'PRODUCTOREFERENCIA.LBL_FUNCIONALIDAD' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
              <div class="col-6 div-form" *ngIf="indObligatorio">
                <p-checkbox label="{{ 'PRODUCTOREFERENCIA.LBL_OBLIGATORIO' | translate}}" binary="true"
                            id="indicadorObligatorio"
                            name="nomindicadorObligatorio"
                            formControlName="indicadorObligatorio">
                </p-checkbox>
              </div>

          </div>
          <div class="col-12 md:col-6 lg:col-6" *ngIf="f.indicadorCalificarReferencias.value">
            <div class="div-form">
              <label>{{'PRODUCTOREFERENCIA.LBL_CUESTIONARIOSCALREF' | translate}}:</label>
              <p-dropdown disableTab  id="idCuestionarioConfirmarReferencia" name="nomIdCuestionarioConfirmarReferencia" [options]="lisCuestionarios"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                           formControlName="idCuestionarioConfirmarReferencia"
                          emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          optionValue="value"
                          optionLabel="label"
              ></p-dropdown>
            </div>
          </div>

        </div>

        </div>
        <div class="grid form-footer-buttons">
          <div class="form-group col-12">
            <div *ngIf="!guardando">
              <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
              <button icon="fa fa-plus" label="{{'BTN_GUARDAR' | translate }}"
                      type="submit"
                      pButton></button>
            </div>
            <div *ngIf="guardando">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
              <span>{{'LBL_GUARDANDO' | translate }}</span>
            </div>
          </div>
        </div>
      </form>
    </div>
  </p-accordionTab>

  <p-accordionTab header="{{ 'PRODUCTOREFERENCIA.LBL_REFMIN' | translate }}" [selected]="tabSeleccionado === 'REFMIN'" [disabled]="">

    <app-producto-referencia-minima [producto]="producto" [lisProductosReferencias]="lisProductosReferencias"
                                    [lisReferenciaTodos]="lisReferenciaTodos" [lisVinculacionTodos]="lisVinculacionTodos"
                                    [refrescar]="refrescar" [listaTiposPersonas]="listaTiposPersonas"
                                    *ngIf="producto && producto.idProducto !== undefined && producto.idProducto !== null && producto.idProducto !== '' && lisProductosReferencias && lisProductosReferencias.length >0">
    </app-producto-referencia-minima>

  </p-accordionTab>

  <p-accordionTab header="{{ 'PRODUCTOREFERENCIA.LBL_REFTITULAR' | translate }}" [selected]="tabSeleccionado === 'REFTITULAR'" [disabled]="">
    <app-referencia-metodo-desembolso [producto]="producto"
                                      *ngIf="producto && producto.idProducto !== undefined && producto.idProducto !== null && producto.idProducto !== '' && lisProductosReferencias && lisProductosReferencias.length >0">
    </app-referencia-metodo-desembolso>

  </p-accordionTab>
</p-accordion>

<p-confirmDialog #cd key="referencias">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
